const AiBoltIcon = ({ style }: SVGOptions) => (
  <svg
    fill="none"
    height="21"
    style={style}
    viewBox="0 0 20 21"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2246 4.19336L10.9688 9.4668H14.25C14.6309 9.4668 14.9824 9.70117 15.1289 10.0527C15.2461 10.4336 15.1582 10.8438 14.8652 11.1074L7.36523 17.6699C7.01367 17.9336 6.54492 17.9629 6.19336 17.6992C5.8418 17.4648 5.69531 16.9961 5.87109 16.5859L8.12695 11.3125H4.875C4.46484 11.3125 4.11328 11.0781 3.99609 10.7266C3.84961 10.3457 3.9375 9.93555 4.23047 9.67188L11.7305 3.10938C12.082 2.8457 12.5508 2.81641 12.9023 3.08008C13.2539 3.31445 13.4004 3.7832 13.2246 4.19336Z"
      fill="url(#paint0_linear_8947_8187)"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_8947_8187"
        x1="10"
        x2="10"
        y1="17.5833"
        y2="2.58333"
      >
        <stop offset="0.00993426" stopColor="#6492F9" />
        <stop offset="0.375" stopColor="#BEEFF5" />
        <stop offset="1" stopColor="#E8F2AB" />
      </linearGradient>
    </defs>
  </svg>
);
export default AiBoltIcon;
